import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#76CE51" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Read stories on the latest entertainment news, such as new
              restaurants or upcoming shows! Filter events by today, this week,
              or this month. Find concerts, family events and so much more!
              Swipe to discover and have fun finding new things to do! Save
              anything you find interesting. You can create your list of
              favorites, sorted by what’s near you in real time.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/intogo/highlights_img_1.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1938}
              height={1104}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
